import { Alert, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { RoutesPaths } from "../../constants/user-routes"
import Icon from "../../Icon"
import { isOnboardingFinished } from "../../Utils/onboarding/isOnboardingFinished"
import { hasSelectedFeature } from "../../Utils/onboarding/selectedFeaturesStorage"

const { Link } = Typography

// Same gate as RecoverConfigureHint (src/Containers/Sidebar/components), surfaced as a
// page-top banner on Home, Recover > All and Recover > Analytics. Styled like Alerts
// page's own "Attention" fullscreen-alert (AlertsPage/index.js) for visual consistency
// between the two products' setup nudges.
const RecoverConfigureBanner = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const userInfo = useSelector((state) => state.auth.userInfo)
  const recoverActivated = useSelector((state) => !!state.disputesConfigure?.profile?.isActivated)
  // Ever activated comes from the backend (RecoverProfile.first_activated_at) rather than
  // a localStorage marker, so a device change no longer makes a set-up merchant look new.
  const everActivated = useSelector((state) => !!state.disputesConfigure?.profile?.everActivated)

  // Also hide once Recover has ever been activated: a merchant who set it up and later
  // deactivated should not be told to "finish setting up" (they'd get the reactivate
  // path instead). Only a merchant still in first-time setup sees this nudge.
  if (
    !isOnboardingFinished(userInfo) ||
    !hasSelectedFeature("recover") ||
    recoverActivated ||
    everActivated
  ) {
    return null
  }

  return (
    <Alert
      type="warning"
      className="fullscreen-alert"
      showIcon
      icon={<Icon type="bell_alarm" />}
      message={
        <>
          {t("Complete Dispute Management setup.")}
          <Link
            onClick={() => navigate(RoutesPaths.recover.configure_section("integrations"))}
            strong
            style={{ marginLeft: 8, zIndex: 2, position: "relative" }}
          >
            {t("Go to Configure")}
          </Link>
        </>
      }
    />
  )
}

export default RecoverConfigureBanner
